/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Outlet, Link } from "react-router-dom";
import Loader from "../Components/Loader";
import { useSelector } from "react-redux";

const ACCOUNT_ICONS = {
  "/accounts/ledgers": "bi bi-diagram-3",
  "/accounts/ledgers/new": "bi bi-diagram-3",
  "/accounts/sales/new": "bi bi-receipt",
  "/accounts/purchases/new": "bi bi-bag",
  "/accounts/receipts/new": "bi bi-box-arrow-in-down",
  "/accounts/payments/new": "bi bi-box-arrow-up-right",
  "/accounts/vouchers": "bi bi-journal-text",
  "/accounts/reports": "bi bi-journal-bookmark",
  "/accounts/reports/ledger-statement": "bi bi-journal-bookmark",
  "/accounts/reports/day-book": "bi bi-calendar3",
  "/accounts/reports/outstanding": "bi bi-cash-stack",
  "/accounts/reports/aging": "bi bi-hourglass-split",
  "/accounts/reports/payables": "bi bi-wallet2",
  "/accounts/customers": "bi bi-people",
  "/accounts/sales/orders": "bi bi-cart",
  "/accounts/sales/loading-advices": "bi bi-truck",
  "/accounts/sales/invoices": "bi bi-receipt",
  "/accounts/vouchers/credit-note": "bi bi-file-minus",
  "/accounts/vouchers/debit-note": "bi bi-file-plus",
  "/accounts/vouchers/journal": "bi bi-journal",
  "/accounts/cheques": "bi bi-credit-card-2-front",
  "/accounts/portal": "bi bi-person",
};

function menuIcon(item) {
  if (item?.hrefLink && ACCOUNT_ICONS[item.hrefLink]) return ACCOUNT_ICONS[item.hrefLink];
  const children = item?.children || [];
  if (children.some((child) => String(child.hrefLink || "").startsWith("/accounts/"))) return "bi bi-journal-text";
  return item?.icon || "";
}

const Leftside = () => {
  const [getMenu, setMenu] = useState([]);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [openSubMenu, setOpenSubMenu] = useState(null);

  const userData = useSelector((state) => state?.user);
  const menuData = useSelector((state) => state?.menu);
  useEffect(() => {
    setMenu(menuData?.data || []);
  }, [menuData]);

  // Toggle body class for layout shift
  useEffect(() => {
    if (isCollapsed) {
      document.body.classList.add("collapsed-sidebar");
    } else {
      document.body.classList.remove("collapsed-sidebar");
    }
  }, [isCollapsed]);

  const LoadParent = ({ value }) => {
    const selectedMenu = localStorage.getItem("menu");
    const selectedSubMenu = localStorage.getItem("submenu");

    if (value.children?.length > 0) {
      const childItem = value.children.map((child_item) => {
        const specCase =
          child_item.name === selectedSubMenu
            ? "nav-link subMenu active"
            : "subMenu collapsed";

        return (
          <li key={child_item.name} className="nav-item">
            <Link
              to={child_item.hrefLink}
              className={specCase}
              onClick={() => {
                localStorage.setItem("menu", value.name);
                localStorage.setItem("submenu", child_item.name);
                setOpenSubMenu(null);
              }}
            >
              <i className={menuIcon(child_item)}></i>
              <span>{child_item.name}</span>
            </Link>
          </li>
        );
      });

      const isSubMenuOpen = openSubMenu === value.name;
      const subMenuStatus = isCollapsed
        ? isSubMenuOpen
          ? "nav-content collapse show"
          : "nav-content collapse"
        : value.name === selectedMenu
          ? "nav-content collapse show"
          : "nav-content collapse";

      return (
        <li
          key={value.name}
          className="nav-item"
          onMouseEnter={() => setOpenSubMenu(value.name)}
          onMouseLeave={() => setOpenSubMenu(null)}
        >
          <a
            href="#"
            className={`nav-link ${value.name === selectedMenu ? "dropdownMenu active" : " collapsed"
              }`}
            data-bs-toggle="collapse"
            data-bs-target={`#${value.data_bs_target}`}
            onClick={(e) => {
              e.preventDefault();
              localStorage.setItem("menu", value.name);
              setOpenSubMenu((prev) =>
                prev === value.name ? null : value.name
              );
            }}
          >
            <i className={menuIcon(value)}></i>
            <span>{value.name}</span>
            <i className="bi bi-chevron-down ms-auto"></i>
          </a>

          <ul
            id={value.data_bs_target}
            className={subMenuStatus}
            data-bs-parent="#sidebar-nav"
          >
            {childItem}
          </ul>
        </li>
      );
    } else {
      const specCase =
        value.name === selectedMenu ? "nav-link active" : "nav-link collapsed";

      return (
        <>
          <li key={value.name} className="nav-item">
            <Link
              to={value.hrefLink}
              className={specCase}
              onClick={() => {
                localStorage.setItem("menu", value.name);
              }}
            >
              <i className={menuIcon(value)}></i>
              <span>{value.name}</span>
            </Link>
          </li>
          <Outlet />
        </>
      );
    }
  };

  return (
    <div
      className="main-sidebar"
      onMouseEnter={() => setIsCollapsed(false)}
      onMouseLeave={() => setIsCollapsed(true)}
    >
      <aside id="sidebar" className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
        <nav>
          <ul className="sidebar-nav" id="sidebar-nav">
            <Loader isLoading={!userData?.status} className={"text-center"} />
            {userData?.status &&
              getMenu?.length > 0 &&
              getMenu.map((value, index) => (
                <LoadParent key={index} value={value} />
              ))}
          </ul>
        </nav>
      </aside>
    </div>
  );
};

export default Leftside;